import { propsMap } from '@/presentation/interfaces';

export const linkIconSize: propsMap = {
  xs: '0.9375rem',
  s: '1.2em',
  m: '1.14em',
  l: '1.2em',
  xl: '2em',
};

export const linkSizeClass: propsMap = {
  xs: 'small',
  s: 'small',
  m: 'medium',
  l: 'large',
  xl: 'large',
};
